import { render, staticRenderFns } from "./ComparisonWrapper.vue?vue&type=template&id=5b421650&"
import script from "./ComparisonWrapper.vue?vue&type=script&lang=js&"
export * from "./ComparisonWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonWrapper.vue?vue&type=style&index=0&id=5b421650&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports